import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'stringReplace'})
export class StringReplacePipe implements PipeTransform {

    transform(value: string, needle: string, replace: string) {
        if (value !== undefined) {
            try {
                value = value.split(needle).join(replace);
            } catch(e){}
        }
        return value;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/reportes/stringreplace.pipe.ts